// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fJitG","leftContent":"styles_leftContent__jFtuE","text":"styles_text__TNZtt"};